/**
 * InfiniteScrollMixin
 *
 * Adds an infinite scroll functionality to a component.
 */
export default {
    data () {
        return {
            infiniteScrollTarget:          null,
            infiniteScrollPage:            1,
            infiniteScrollEnabled:         true,
            infiniteScrollChildrenWrapper: null
        };
    },

    methods: {
        /**
         * Disable infinite scroll.
         *
         * @return {void}
         */
        disableInfiniteScroll () {
            this.infiniteScrollEnabled = false;
        },

        /**
         * Enable infinite scroll.
         *
         * @return {void}
         */
        enableInfiniteScroll () {
            // Add a delay so it doesn't trigger right away
            const delay = 500;
            setTimeout(() => {
                this.infiniteScrollEnabled = true;
            }, delay);
        },

        /**
         * Handle the scroll event.
         *
         * @param  {object}  event     The scroll event
         * @param  {object}  position  The position data
         * @return {void}
         */
        infiniteScroll (event) {
            // Ignore if is disabled
            if (!this.infiniteScrollEnabled) {
                return;
            }

            // Warn if the infiniteScrollEndReached method is not defined
            if (this.infiniteScrollEndReached === undefined) {
                return;
            }

            this.infiniteScrollTarget = event.target.id;

            // Get the position of the scroll via the event/position
            const isAtBottom = this.infiniteScrollChildrenWrapper === null
                ? Math.abs(event.target.scrollHeight - (event.target.scrollTop + event.target.clientHeight)) < 1
                : Math.abs(this.infiniteScrollChildrenWrapper.scrollHeight - (this.infiniteScrollChildrenWrapper.scrollTop + this.infiniteScrollChildrenWrapper.clientHeight)) < 1;

            // Check if the scrollTop has reached the top of the last child
            if (isAtBottom) {
                // Increment the page
                this.infiniteScrollPage++;

                // Call the callback
                this.infiniteScrollEndReached(this.infiniteScrollPage);
            }
        },

        /**
         * Handle the scroll event.
         *
         * @param  {object}  event     The scroll event
         * @param  {object}  position  The position data
         * @return {void}
         */
        infiniteScrollOpposite (event, position) {
            // Ignore if is disabled
            if (!this.infiniteScrollEnabled) {
                return;
            }

            // Warn if the infiniteScrollEndReached method is not defined
            if (this.infiniteScrollEndReached === undefined) {
                return;
            }

            this.infiniteScrollTarget = event.target.id;

            // Get the position of the scroll via the event/position
            let firstChildTop   = 0;
            const boundingRect  = event.target.getBoundingClientRect();
            const scrollPointer = position.scrollTop;

            if (this.infiniteScrollChildrenWrapper === null) {
                firstChildTop = Math.floor(event.target.scrollHeight - boundingRect.height);
            } else {
                firstChildTop = this.infiniteScrollChildrenWrapper.scrollHeight - this.infiniteScrollChildrenWrapper.getBoundingClientRect().top;
            }

            // Check if the scrollTop has reached the top
            if (-scrollPointer >= firstChildTop) {
                // Increment the page
                this.infiniteScrollPage++;

                // Call the callback
                this.infiniteScrollEndReached(this.infiniteScrollPage);
            }
        }
    }
};
